import React from 'react';
import Page from '../../Components/Page';

function NotFound() {
  return <Page title='Page Not Found' />;
}

export default NotFound;
